export default __webpack_public_path__ + "static/media/google-drive-step-2.d91e39d7.png";